import React from 'react';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select-plus';

const employeeOption = (employee) => (
  <span>
    <FontAwesome name="square" style={{ color: '#fafafa' }} />
    {` ${employee.firstName +' '+ employee.lastName }` }
  </span>
);

const EmployeesDropdown = ({employees, ...props }) => (
    <Select
    labelKey="value"
    multi
    optionRenderer={employeeOption}
    options={employees}
    placeholder="All"    
    valueKey="id"
    valueRenderer={employeeOption}
    onChange={(e) => onFormUpdate({ employees: e })}
  />
);

export default EmployeesDropdown;
